const spinningSubmitDefinition = {
  type: 'input',
  schema: [
    {
      $cmp: 'FormKit',
      bind: '$submitAttrs',
      props: {
        ignore: true,
        type: 'submit',
        disabled: '$disabled',
        label: '$submitLabel',
      },
      children: [
        '$label',
        {
          if: '$disabled',
          $el: 'span',
          children: [' submitting...'],
        },
      ],
    },
  ],
}

export const customInputs = () => {}
customInputs.library = node => {
  if (node.props.type === 'spinningSubmit') {
    node.define(spinningSubmitDefinition)
  }
}
